import React from 'react';

import styles from './ArtistItem.module.scss';

const ArtistItem = ({artist:{name, images, genres, href, uri}}) => {

  return (
    <div onClick={()=>window.location=uri} className={styles.artistItemContainer}>
      <div className={styles.imgContainer}>
        <img src={images[0].url} alt={`${name}`}/>
      </div>
        <h5>{name}</h5>
    </div>
  )

}

export default ArtistItem;